// src/components/notifications/NotificationsMobileFab.jsx
import React from 'react';
import { Fab } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import PermissionGate from '../../auth/components/PermissionGate';

export default function NotificationsMobileFab() {
  const navigate = useNavigate();

  const handleNavigateToCreate = () => {
    navigate('/notifications/create');
  };

  return (
    <PermissionGate scope="notification:create">
      <Fab
        color="primary"
        aria-label="create notification"
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          display: { xs: 'flex', sm: 'none' },
        }}
        onClick={handleNavigateToCreate}
      >
        <AddIcon />
      </Fab>
    </PermissionGate>
  );
}